import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, shareReplay } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  private host = environment.APIUrl;
  private dashboardDataSubject = new BehaviorSubject<any>(null); // To hold the dashboard data
  private loadingSubject = new BehaviorSubject<boolean>(false); // To manage loading state

  constructor(private http: HttpClient) {}

  // This will be the observable that components subscribe to
  getDashboardData(id: number): Observable<any> {
    // If data is already available in the BehaviorSubject, return it
    if (this.dashboardDataSubject.value) {
      return this.dashboardDataSubject.asObservable();
    }

    // Otherwise, make the API call
    return this.loadDashboardData(id);
  }

  private loadDashboardData(id: number): Observable<any> {
    // Set loading state to true
    this.loadingSubject.next(true);

    // Make the HTTP GET request to fetch the data
    return this.http.get(`${this.host}employer-dashboard-all-counts/`).pipe(
      // Update the BehaviorSubject with the fetched data
      shareReplay(1), // Ensure multiple subscribers get the same data without extra API calls
      catchError((error) => {
        console.error("Error fetching data:", error);
        throw error;
      })
    );
  }

  // To manually update the data in the BehaviorSubject if needed
  updateDashboardData(data: any): void {
    this.dashboardDataSubject.next(data);
  }

  // Get the loading state
  get loading$(): Observable<boolean> {
    return this.loadingSubject.asObservable();
  }

  getDashboardListData(category: string, page: number): Observable<any> {
    let params = new HttpParams().set("page", page.toString());
    return this.http.get(
      `${this.host}employer-dashboard-details/?category=${category}`,
      { params }
    );
  }
  getDashboard_Data(projectId:any): Observable<any[]> {
    return this.http.get<any>(`${this.host}employer-dashboard-all-counts/?project=${projectId}`);
  }
  getAllocatedProjects(): Observable<any> {
    return this.http.get(`${this.host}allocated-projects/`);
  }
}
